import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { EVENT_ASSOCIATION_TABS, EVENT_ROUTE, associationEventType } from '../../../../constants';

import classes from './AssociationNavigation.module.scss';

const AssociationNavigation = () => {
  const [toggle, setToggle] = useState(1);

  const history = useNavigate();
  const { t: translate } = useTranslation();
  const { eventName = '', eventVersion = '', associationTab } = useParams();

  useEffect(() => {
    if (associationTab) {
      if (associationTab === EVENT_ASSOCIATION_TABS.SOURCES) {
        setToggle(1);
      } else if (associationTab === EVENT_ASSOCIATION_TABS.SERVICES) {
        setToggle(2);
      }
    }
  }, [associationTab]);

  const handleTabs = (tabIndex: number) => {
    switch (tabIndex) {
      case 1:
        setToggle(tabIndex);
        history(`${EVENT_ROUTE.ASSOCIATIONS_ROUTE}${eventName}/${eventVersion}/${EVENT_ASSOCIATION_TABS.SOURCES}`);
        break;
      case 2:
        setToggle(tabIndex);
        history(`${EVENT_ROUTE.ASSOCIATIONS_ROUTE}${eventName}/${eventVersion}/${EVENT_ASSOCIATION_TABS.SERVICES}/${associationEventType.INGRESS}`);
        break;
      default:
        break;
    }
  };

  return (
    <Row className={`${classes['association-nav-container']}`}>
      <Col md={12}>
        <div className={classes['nav-btn']}>
          <div className={classes.tab}>
            <ul>
              <li
                className={`${classes.appTab} ${toggle === 2 ? classes.onActive : ''
                  }`}
                onClick={() => handleTabs(2)}
                data-testid="services-tab"
                aria-hidden
              >
                {translate('event_associations.lbl_nav_services')}
              </li>
              <li
                className={`${classes.appTab} ${toggle === 1 ? classes.onActive : ''
                  }`}
                onClick={() => handleTabs(1)}
                data-testid="sources-tab"
                aria-hidden
              >
                {translate('event_associations.lbl_nav_sources')}
              </li>
            </ul>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default AssociationNavigation;
